import { toRepeatQuery } from './queryString'
import { DownloadErpDocumentSummariesReq, GetErpDocumentsReq } from './types'

/**
 * EST04(신규) 재고이동확정 화면이 쓰는 엔드포인트.
 *
 * 동작별 배선 (LOGISPRD-10670 기준표):
 * | 동작            | 2.0 API                                                | 1.0 API                             | 비고                                      |
 * |-----------------|--------------------------------------------------------|-------------------------------------|-------------------------------------------|
 * | 화면            | —                                                      | —                                   | FE 전용 신규 페이지(est04), 기존 est01(iframe) 유지 |
 * | 조회(HEAD)      | `GET /api/v1/stock-transfer/erp-documents/summary`     | /api/grid/search (EST01_HEAD)       |                                           |
 * | 조회(ITEM)      | `GET /api/v1/stock-transfer/erp-documents`             | /api/grid/search (EST01_ITEM)       | 무필터 400 가드 — 항상 ordNo 를 실어 호출  |
 * | 저장            | `POST /api/v1/stock-transfer/erp-documents/save`       | /api/grid/save                      | 업로드도 이 API 경유(이번 범위 밖)         |
 * | 확정            | `POST /api/v1/confirm-stock-transfer`                  | —                                   | 07:30~08:10 서버 차단                      |
 * | 삭제            | `POST /api/v1/stock-transfer/erp-documents/delete`     | /api/internal/data/send (RM_STO_IN_OMS) | auth0 전용                             |
 * | 삭제이력        | `GET /api/v1/stock-transfer/remove-logs?category=STO`  | /api/grid/search (ERP_LOG)          | auth0 전용. category='STO'(1.0 removeSto 기록값) |
 * | 다운로드(HEAD)  | `GET /api/v1/stock-transfer/erp-documents/summary/excel` | — (1.0 은 FE 로컬 생성)           | 서버 xlsx. detailedReason 5자 이상 필수    |
 * | 다운로드(ITEM)  | — (ag-Grid 클라이언트 생성)                            | — (동일)                            | 서버 API 없음(1.0 동치)                    |
 */
export const ERP_DOCUMENTS_URL = '/api/v1/stock-transfer/erp-documents'
export const ERP_DOCUMENT_SUMMARIES_URL = `${ERP_DOCUMENTS_URL}/summary`
export const ERP_DOCUMENT_SUMMARIES_EXCEL_URL = `${ERP_DOCUMENT_SUMMARIES_URL}/excel`
export const ERP_DOCUMENTS_SAVE_URL = `${ERP_DOCUMENTS_URL}/save`
export const ERP_DOCUMENTS_DELETE_URL = `${ERP_DOCUMENTS_URL}/delete`
export const CONFIRM_STOCK_TRANSFER_URL = '/api/v1/confirm-stock-transfer'
export const REMOVE_LOGS_URL = '/api/v1/stock-transfer/remove-logs'

/** HEAD(문서) 조회 URL. */
export const buildErpDocumentSummariesUrl = (params: GetErpDocumentsReq) => `${ERP_DOCUMENT_SUMMARIES_URL}?${toRepeatQuery(params)}`

/** ITEM(품목) 조회 URL. BE 는 무필터 호출을 400 으로 막는다 — 호출부가 최소 1개 필터를 보장한다. */
export const buildErpDocumentsUrl = (params: GetErpDocumentsReq) => `${ERP_DOCUMENTS_URL}?${toRepeatQuery(params)}`

/** HEAD 엑셀 다운로드 URL. blob 으로 받아 저장한다. */
export const buildErpDocumentSummariesExcelUrl = (params: DownloadErpDocumentSummariesReq) =>
  `${ERP_DOCUMENT_SUMMARIES_EXCEL_URL}?${toRepeatQuery(params)}`
